export default __webpack_public_path__ + "static/media/2s.1e5dba91.png";